import { graphql } from "../gql";

export const OneOnOneAssignmentPdfFragment = graphql(`
  fragment OneOnOneAssignmentPdf on OneOnOneAssignmentPdf {
    pdfUrl
    userGroup {
      slug
      id
      name
    }
    userGroupId
    level
    oneOnOneLessonType
    assignmentNumber
    businessEnglishObjective
  }
`);
